import "./Hero.css";
import { Link } from "react-router-dom";

const HeroSlide9 = () => {
const fastserve = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-fast-serve_png.png";


  return (
    <Link to="https://apps.apple.com/in/app/izb-nxt/id6754076496" target="_blank">
      <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_BANNER_House_desktop 1a.jpg" alt="hero-banner-desktop" className="hide-on-mobile home-hero-banner" />
      <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB_BANNER_House_mobile 1a.jpg" alt="hero-banner-mobile" className="hide-on-desktop home-hero-banner" />
    </Link>
  );
};

export default HeroSlide9;